var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isHttpRequestAsyncHandler, isHttpRequestEmulatorConstructor, isHttpRequestRegExpAsyncHandler, } from './Emulator';
import { emulators } from './Emulators';
export class HttpRequestEmulator {
    constructor(key, logFactory) {
        const [name, Emulator] = this.getEmulator(key);
        this.log = logFactory.channel('HttpRequestEmulator');
        if (isHttpRequestEmulatorConstructor(Emulator)) {
            this._emulator = new Emulator(logFactory.channel(name));
        }
        else {
            throw new Error('unsupported emulator type');
        }
    }
    // getters and setters
    get emulator() {
        return this._emulator;
    }
    // public methods
    acceptAllCerts(accept) {
        return __awaiter(this, void 0, void 0, function* () {
            // Nothing to do.
        });
    }
    sendRequest(req) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            let response;
            for (const handler of this._emulator.asyncHandlers) {
                if ('method' in handler && handler.method !== req.method)
                    continue;
                if (isHttpRequestAsyncHandler(handler)) {
                    if (req.path === handler.path) {
                        response = yield handler.callback(req);
                        break;
                    }
                }
                else if (isHttpRequestRegExpAsyncHandler(handler)) {
                    const match = handler.path.exec(req.path);
                    if (match) {
                        response = yield handler.callback(match, req);
                        break;
                    }
                }
                else {
                    this.log.error('invalid async handler');
                }
            }
            if (response === undefined) {
                this.log.error(`request not handled by emulator: ${JSON.stringify(req, null, 4)}`);
                response = { status: 404 };
            }
            const fullResponse = {
                headers: (_a = response.headers) !== null && _a !== void 0 ? _a : {},
                status: (_b = response.status) !== null && _b !== void 0 ? _b : 200,
                url: `${req.scheme}://${req.host}${req.path}`,
            };
            if ('data' in response) {
                if (typeof response.data === 'string') {
                    fullResponse.data = response.data;
                }
                else {
                    // Convert data to string, like driver would receive from server.
                    fullResponse.data = JSON.stringify(response.data);
                }
            }
            else {
                fullResponse.error = (_c = response.error) !== null && _c !== void 0 ? _c : 'unknown';
            }
            return fullResponse;
        });
    }
    // private methods
    getEmulator(key) {
        for (const [name, Emulator] of Object.entries(emulators)) {
            if (Emulator.key === key)
                return [name, Emulator];
        }
        throw new Error(`no emulator found for key: ${key}`);
    }
}
